var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.536 8.464a1 1 0 0 1 .003 1.411L9.876 15.54a1 1 0 0 1-1.414-1.414l5.663-5.664a.995.995 0 0 1 1.41.003ZM8.465 19.778a3.003 3.003 0 0 1-4.243 0 3.002 3.002 0 0 1 0-4.242l2.828-2.829a1 1 0 1 0-1.414-1.414L2.808 14.12a5.002 5.002 0 0 0 0 7.071 5.003 5.003 0 0 0 7.07 0l2.83-2.828a1 1 0 1 0-1.415-1.414l-2.828 2.828Zm12.727-9.9a5.003 5.003 0 0 0 0-7.07 5.002 5.002 0 0 0-7.07 0l-2.829 2.828a1 1 0 0 0 1.414 1.414l2.829-2.828a3.002 3.002 0 0 1 4.242 0 3.003 3.003 0 0 1 0 4.242l-2.828 2.829a1 1 0 0 0 1.414 1.414l2.828-2.828Z"
  })));
};

export default SvgLink;